import ModelProxy, {required, optional} from './proxy';


export default class ExportedTableRow extends ModelProxy {

  static propTypes = {
    accession: required,
    ptAlias: required,
    region: required,
    isChild: required,
    source: required,
    genes: required,
    subtype: required,
    drms: required,
    isolateName: required,
    isolateDate: required,
    regimen: optional,
    optionalDate: optional,
    weeks: optional,
    regimen2: optional,
    optionalDate2: optional,
    weeks2: optional,
    possibleAdditionalPastARVs: optional
  };

}



// WEBPACK FOOTER //
// ./src/models/exported-table-row.js